import * as _ from './helpers'

export function init () {
  // get all the share buttons and attach a click event to them
  _.clickEvent('.js-share', event => {
    // stop the event bubbling up the DOM
    event.stopPropagation()
    // stop clicking the button from actually going to a URL
    event.preventDefault()

    // set the location of the popup window
    const winTop = _.windowHeight / 2 - _.windowHeight / 2
    const winLeft = _.windowWidth / 2 - _.windowWidth / 2

    // get the element in the page that holds all the data
    const dataObject = document.querySelector('.js-share-info')

    // assign the data to variables
    const url = encodeURIComponent(window.location.href)
    const title = encodeURIComponent(dataObject.getAttribute('data-title'))

    // open a window based on which button was clicked
    if (event.currentTarget.classList.contains('-twitter')) {
      window.open(
        'https://twitter.com/intent/tweet?' +
          '&text=' +
          title +
          '&url=' +
          url +
          '&via=rocol',
        'sharer',
        'top=' +
          winTop +
          ',left=' +
          winLeft +
          ',toolbar=0,status=0,width=520,height=350'
      )
    } else if (event.currentTarget.classList.contains('-email')) {
      window.location.href =
        'mailto:enteraddress?subject=' + title + '&body=' + url
    } else if (event.currentTarget.classList.contains('-linkedin')) {
      window.open(
        'https://www.linkedin.com/shareArticle?' +
          'mini=true' +
          '&url=' +
          url +
          '&title=' +
          title +
          '&source=ROCOL&target=new',
        '_blank',
        'top=' +
          winTop +
          ',left=' +
          winLeft +
          ',toolbar=0,status=0,width=520,height=350'
      )
    }
  })
}



// WEBPACK FOOTER //
// ./resources/assets/js/core/share.js